import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchProjectdossiers'
import type { ProjectdossiersSearch } from '../types/ProjectdossiersSearch'

export { useProjectdossiersSearchStore }

const useProjectdossiersSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<ProjectdossiersSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
